import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginSuccessComponent } from './open_id/login-success/login-success.component';
import { LoginFailComponent } from './open_id/login-fail/login-fail.component';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { GenericFailComponent } from './errors/generic-fail/generic-fail.component';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { configGuard } from './app/guards/config.guard';
import { LoginErrorComponent } from './open_id/login-error/login-error.component';
// import { LoginComponent } from './login/login.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'app' },
  {
    path: 'login-ok',
    component: LoginSuccessComponent,
  },
  {
    path: 'login-unauth',
    component: LoginFailComponent,
  },
  {
    path: 'login-error',
    component: LoginErrorComponent,
  },
  {
    path: 'app',
    canActivate: [autoLoginPartialRoutesGuard, configGuard],
    loadChildren: () => import('./app/app.module').then((m) => m.AppModule),
  },
  { path: '500', component: GenericFailComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class MainRoutingModule {}
